import React from 'react';
import {Flex, Input} from "antd";
import IntlMessage from "../../../../../../components/IntlMessage/IntlMessage";
import classes from "../../../Applications/application.module.css";

const CommentsSection = ({comments}) => {
    if (!comments || comments.length === 0) {
        return null;
    }

    return (
        <Flex vertical gap={"small"}>
            <IntlMessage id={"applicationsPage.comment"}/>
            {comments.map((c, index) => (
                <Input.TextArea
                    key={index}
                    rootClassName={classes.formInput}
                    value={c.comment}
                    readOnly
                />
            ))}
        </Flex>
    );
};

export default CommentsSection;
